import { MessageBackend as createMessageBackendJiraFilterRefinementTmpBacklog, MessageFrontend as createMessageFrontendJiraFilterRefinementTmpBacklog } from '@post-office/message-template--jira-filter-refinement-tmp-backlog/placements/in-app-v2/jira-filter-refinement-filter-button'
import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import { PlacementBackend, PlacementFrontend } from '@post-office/placements--jira-empanada/jira-filter-refinement-filter-button';


import { withI18n } from './i18n';

const messageBackends = [
createMessageBackendJiraFilterRefinementTmpBacklog({messageTemplateId: 'jira-filter-refinement-tmp-backlog'}),
]

const messageFrontends = [
createMessageFrontendJiraFilterRefinementTmpBacklog({messageTemplateId: 'jira-filter-refinement-tmp-backlog'}),
]

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
				messageTemplates: messageBackends,
			})

export const RawPlacement = PlacementFrontend.createPlacementFrontendComponent({
				messageTemplates: messageFrontends
			});

export const Placement = withI18n(RawPlacement)

export const SSRPlacement = RawPlacement

export const middleware = placementBackendFactory(productionRuntime);